import { render, staticRenderFns } from "./UnsupportedWidget.vue?vue&type=template&id=67684746&scoped=true"
import script from "./UnsupportedWidget.vue?vue&type=script&lang=js"
export * from "./UnsupportedWidget.vue?vue&type=script&lang=js"
import style0 from "./UnsupportedWidget.vue?vue&type=style&index=0&id=67684746&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67684746",
  null
  
)

export default component.exports